import en from "./en.json";
import ja from "./ja.json";

export const LOCALES = {
  ja: {
    translation: ja,
    label: "日本語",
  },
  en: {
    translation: en,
    label: "English",
  },
};

export const DEFAULT_LOCALE = "en";
